<template>
    <div class="clip-mask-wrapper" @mousedown="movingStart" @mousemove="mouseMove" @mouseup="mouserUp">
        <div class="mask-top" :style="topStyle"></div>
        <div class="mask-middle">
            <div class="mask-middle-left" :style="leftStyle"></div>
            <div class="mask-middle-center" :style="centerStyle" attr-v="moving">
                <div class="clip-dot left-top" attr-v="lefttop" v-show="!isAspact"></div>
                <div class="clip-dot top" attr-v="top"></div>
                <div class="clip-dot right-top" attr-v="righttop" v-show="!isAspact"></div>
                <div class="clip-dot left" attr-v="left"></div>
                <div class="clip-dot right" attr-v="right"></div>
                <div class="clip-dot left-bottom" attr-v="leftbottom" v-show="!isAspact"></div>
                <div class="clip-dot bottom" attr-v="bottom"></div>
                <div class="clip-dot right-bottom" attr-v="rightbottom" v-show="!isAspact"></div>
            </div>
            <div class="mask-middle-right"></div>
        </div>
        <div class="mask-bottom"></div>                    
    </div>
</template>

<script>

export default {
    name: "ClipMask",
    props: ["top", "left", "width", "height", "isAspact"],
    computed: {
        topStyle() {
            return {
                height: this.top + 'px',
            }
        },
        centerStyle() {
            return {
                width: this.width + 'px',
                height: this.height + 'px',
            }
        },
        leftStyle() {
            return {
                width: this.left + 'px',
            }
        }
    },
    methods: {
        movingStart(event) {
            const target = event.target;
            const attrV = target.getAttribute('attr-v');
            if (!attrV) {
                return;
            }

            attrV == "moving" ? this.isMoving = true : this.resizing = true;

            this.startX = event.pageX;
            this.startY = event.pageY;
            this.attrV = attrV;

            window.document.addEventListener('mouseup', this.mouserUp);
        },
        mouseMove(event) {
            if (!this.isMoving && !this.resizing) {
                return;
            }
            
            const curX = event.pageX;
            const curY = event.pageY;
            
            this.isMoving && this.$emit("moving", {
                x: curX - this.startX,
                y: curY - this.startY,
            });

            this.resizing && this.$emit("resizing", {
                x: curX - this.startX,
                y: curY - this.startY,
                direct: this.attrV,
            });

            this.startX = event.pageX;
            this.startY = event.pageY;
        },
        mouserUp(event) {
           this.isMoving = false;
           this.resizing = false;
           window.document.removeEventListener('mouseup', this.mouserUp);
        }
    }
}
</script>

<style scoped lang="scss">
$clipMaskColor: #666666;
$clipDotRadius: 4px;

.clip-mask-wrapper {
    display: flex;
    flex-direction: column;

    .mask-middle-right,
    .mask-bottom {
        opacity: 0.3;
        background-color: $clipMaskColor;
        flex-grow: 1;
        flex-shrink: 1;
    }

    .mask-middle-left,
    .mask-top,
    .mask-middle-right {
        opacity: 0.3;
        background-color: $clipMaskColor;
    }

    .mask-middle-left,
    .mask-top,
    .mask-middle,
    .mask-middle-center {
        flex-grow: 0;
        flex-shrink: 0;
    }

    .mask-middle {
        display: flex;
    }

    .mask-middle-center {
        border: 1px solid #2EC2FF;
        box-sizing: border-box;
        position: relative;
        cursor: move;

        .clip-dot {
            background-color: #3FA7D2;
            opacity: 0.9;
            width: 2 * $clipDotRadius;
            height: 2 * $clipDotRadius;
            border-radius: 50%;
            position: absolute;
        }

        .left-top {
            left: -1 * $clipDotRadius;
            top: -1 * $clipDotRadius;
            cursor: nw-resize;
        }

        .top {
            left: calc(50% - 4px);
            top: -1 * $clipDotRadius;
            cursor: n-resize;
        }

        .right-top {
            right: -1 * $clipDotRadius;
            top: -1 * $clipDotRadius;
            cursor: ne-resize;
        }

        .left {
            left: -1 * $clipDotRadius;
            top: calc(50% - 4px);
            cursor: w-resize;
        }

        .right {
            right: -1 * $clipDotRadius;
            top: calc(50% - 4px);
            cursor: e-resize;
        }

        .left-bottom {
            left: -1 * $clipDotRadius;
            bottom: -1 * $clipDotRadius;
            cursor: sw-resize;
        }

        .bottom {
            left: calc(50% - 4px);
            bottom: -1 * $clipDotRadius;
            cursor: s-resize;
        }

        .right-bottom {
            right: -1 * $clipDotRadius;
            bottom: -1 * $clipDotRadius;
            cursor: se-resize;
        }
    }

    
}
</style>